import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGreenPower: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconGreenPower"><Path fillRule="evenodd" clipRule="evenodd" d="M5.01382 17.572C2.15358 13.6054 2.37669 9.2325 5.11588 6.22156C7.9679 3.08658 13.2823 1.72043 19.7698 3.53692L20.3115 3.68859L20.4632 4.23026C22.2796 10.7178 20.9135 16.0322 17.7785 18.8842C14.7675 21.6233 10.3947 21.8464 6.42803 18.9862L4.00015 21.4141L2.58594 19.9999L5.01382 17.572ZM9.00012 12.4999L13.5001 6.99994V10.4999H16.0001L11.5001 15.9999V12.4999H9.00012Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGreenPower;
